import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-06fc0f9d")

_pushScopeId("data-v-06fc0f9d")
const _hoisted_1 = { class: "component-status-steps-box" }
const _hoisted_2 = { class: "step-header" }
const _hoisted_3 = {
  key: 0,
  class: "step-overlay"
}
const _hoisted_4 = { class: "step-overlay-loading-wrapper" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_loading = _resolveComponent("van-loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataList, (item, index) => {
      return (_openBlock(), _createBlock("div", {
        key: index,
        class: "status-step-item"
      }, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h3", {
            textContent: _toDisplayString(item.title)
          }, null, 8, ["textContent"])
        ]),
        _createVNode("div", {
          class: "step-body",
          style: { minHeight: _ctx.datqListMap[index]?.loading ? '70px':'unset', }
        }, [
          (_ctx.datqListMap[index]?.loading)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_van_loading, {
                    type: "spinner",
                    color: "#1989fa"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode("div", {
            innerHTML: item.content
          }, null, 8, ["innerHTML"]), [
            [_vShow, _ctx.datqListMap[index]?.showBody]
          ])
        ], 4),
        _createVNode("div", {
          class: "step-side-dot",
          style: _ctx.getDotStyle(index)
        }, null, 4),
        _createVNode("div", {
          class: "step-side-line",
          style: _ctx.getLineStyle(index)
        }, null, 4)
      ]))
    }), 128))
  ]))
})